<template>
  <div class="exBranding-monitoring">
    <div v-if="!isLoading" class="exBranding-monitoring__header">
      <div class="exBranding-monitoring__header__title">
        <h1 class="xsmall-title to-uppercase">{{campaign_title}}</h1>
      </div>
      <div class="exBranding-monitoring__header__period">
        <adx-labelstatus class="status" :progress="displayStatus('active')"/>
        <span class="subhead period-text color-grey"> Campaign period {{displayPeriod(startDate, endDate)}} </span>
      </div>
    </div>
    <!-- First Content - Overview -->
    <div v-if="!isLoading" class="exBranding-monitoring__first-content">
      <div v-if="!loadingOverview" class="exBranding-monitoring__first-content__wrapper">
        <div class="exBranding-monitoring__first-content__overview">
          <span class="medium-title bold">Overview</span>
          <span v-if="latestUpdated">Last updated on {{formatDate(latestUpdated)}}</span>
        </div>
        <div class="exBranding-monitoring__first-content__card-wrapper">
          <div class="card__normal">
            <div class="color-white space strong">
              NORMAL
            </div>
            <div>
              <span class="color-white large-title strong">{{ normal }}</span>
              <span class="color-white strong"> Of {{ placements.length }} PLACEMENTS</span>
            </div>
          </div>
          <div class="card__warning">
            <div class="color-white space strong">
              WARNING
            </div>
            <div>
              <span class="color-white large-title strong">{{ warning }}</span>
              <span class="color-white strong"> Of {{ placements.length }} PLACEMENTS</span>
            </div>
          </div>
          <div class="card__outservice">
            <div class="color-white space strong ">
              OUT OF SERVICE
            </div>
            <div>
              <span class="color-white large-title strong">{{ out_of_service }}</span>
              <span class="color-white strong"> Of {{ placements.length }} PLACEMENTS</span>
            </div>
          </div>
        </div>
        <div class="exBranding-monitoring__first-content__subwrapper">
          <div class="placement space">
            <div class="placement__title">
              <h1 class="subhead">STATUS PER PLACEMENT</h1>
            </div>
            <div class="placement__campainRange">
              <div class="placement__campainRange__table-content">
                <div>
                  <table>
                    <thead class="none">
                      <tr>
                        <td class="issue header-1"></td>
                        <td class="issue header-2"></td>
                      </tr>
                    </thead>
                    <tbody v-if="placements.length !== 0">
                      <tr v-for="(item, index) in slicedPlacement" :key="index" class="content">
                        <td class="id mini-font">{{item.placement}}</td>
                        <td>
                          <adx-labelstatus class="dropdownDoc__item" :progress='item.status'/>
                        </td>
                      </tr>
                    </tbody>
                    <div v-else class="empty-status">
                      <span>Data not available</span>
                    </div>
                  </table>
                </div>
              </div>
              <div class="placement__campainRange__range" >
                <span>Page {{ placementPage }} of {{ this.placementMaxPage }}</span>
                <i class="adx-ic_chevron_down" @click.stop="nextPlacement()"></i>
                <i class="adx-ic_chevron_up" @click.stop="previousPlacement()"></i>
              </div>
            </div>
          </div>
          <div class="status">
            <div class="status__title">
              <h1 class="subhead">ALL TIMES STATUS UPDATES</h1>
            </div>
            <!-- <div class="status__choice">
              <div class="rectangle-1"></div>
              <div class="choice">Normal</div>
              <div class="rectangle-2"></div>
              <div class="choice">Warning</div>
              <div class="rectangle-3"></div>
              <div class="choice">Critical</div>
            </div> -->
            <div class="status__table-content">
              <div>
                <table>
                  <thead class="none">
                    <tr>
                      <td class="issue header-1"></td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in status" :key="index" class="content">
                      <td>
                        <adx-list-item :data='item.data' :type="`bar-color`" :color='item.color'/>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="exBranding-monitoring__first-content__loading" >
        <adx-loading-primary class="loading-item"/>
      </div>
    </div>
    <!-- Second Content - Placement and location -->
    <div class="exBranding-monitoring__second-content">
      <div class="content">
        <div class="content__wrapper">
          <adx-selectdropdown class="space" :label="`Location`" :value="selectedLocation" :options="locations" @selected="onLocationSelected" />
          <adx-selectdropdown :label="`Placement`" :value="selectedOption" :options="options" @selected="onPlacementSelected"/>
        </div>
        <div>
          <adx-empty class="empty" v-if="contents.length === 0" :title="`Ooops,,,`"
          :subtitle="`We still don’t have any data to show right now.`"/>
          <div class="table-content" >
            <div>
              <table>
                <thead class="none">
                  <tr>
                    <td class="issue header-1 mini-font">DATE</td>
                    <td class="issue header-2 mini-font">IMAGE</td>
                    <td class="issue header-3 mini-font">STATUS</td>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in contents" :key="index" class="content">
                    <td class="id">{{formatDate(item.date)}}</td>
                    <td class="location">
                      <div class="location__wrapper">
                        <div  v-for="(item, index) in item.images" :key="index"  class="image"><img class="thumbnail" :src='item.thumbnail' alt="" @click="imagePreview(item)"></div>
                        <!-- <div class="image"><img :src='item.image_2' alt="" @click="imagePreview(item)"></div> -->
                      </div>
                    </td>
                    <td>
                      <adx-labelstatus class="dropdownDoc__item" :progress='item.status'/>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div v-if="optionImages.max_page > 1" class="exBranding-monitoring__second-content__range" >
              <span>Page {{ optionImagesPage }} of {{ optionImages.max_page }}</span>
              <i class="adx-ic_chevron_down" @click.stop="nextImages()"></i>
              <i class="adx-ic_chevron_up" @click.stop="previousImages()"></i>
            </div>
          </div>
        </div>
      </div>
      <!-- <div v-else class="loading" >
        <adx-loading-primary class="loading-item"/>
      </div> -->
    </div>
    <!-- Third Content -  Issue List -->
    <div v-if="!isLoading" class="exBranding-monitoring__third-content">
      <div class="exBranding-monitoring__third-content__title">
        <h1 class="large-font bold">Issue List</h1>
      </div>
      <div v-if="!loadingIssue">
        <adx-empty class="empty" v-if="slicedIssueList.length === 0" :title="`Ooops,,,`"
          :subtitle="`We still don’t have any data to show right now.`"/>
        <div class="content" v-if="slicedIssueList.length !== 0">
          <div>
            <table>
              <thead class="none">
                <tr>
                  <td class="issue header-1 mini-font">ISSUE ID</td>
                  <td class="issue header-2 mini-font">LOCATION</td>
                  <td class="issue header-3 mini-font">ISSUE</td>
                  <td class="issue header-4 mini-font">DATE</td>
                  <td class="issue header-5 mini-font">STATUS</td>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in slicedIssueList" :key="index" class="content">
                  <td class="id subhead">{{item.id}}</td>
                  <td class="location">
                    <div class="location__wrapper">
                      <div class="bold subhead">{{item.listing_location}}</div>
                      <div class="subhead">{{item.listing_placement}}</div>
                    </div>
                  </td>
                  <td class="issue_desc subhead">{{item.type_display}}</td>
                  <td class="date subhead">{{formatShortDate(item.date)}}</td>
                  <td class="status subhead">{{item.status_display}}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-if="items_issue.length > 10" class="exBranding-monitoring__third-content__range" >
            <span>Page {{ issuesPage }} of {{ this.issueMaxPage }}</span>
            <i class="adx-ic_chevron_down" @click.stop="nextIssues()"></i>
            <i class="adx-ic_chevron_up" @click.stop="previousIssues()"></i>
          </div>
        </div>
      </div>
      <div v-else class="loading" >
        <adx-loading-primary class="loading-item"/>
      </div>
    </div>
    <div class="exBranding-monitoring__loading">
      <adx-loading v-if="isLoading"/>
    </div>
  </div>
</template>

<script>
  import moment from 'moment'
  import Empty from '@/components/NotFound/Selection'
  import Loading from '@/components/Loading/Primary'
  import SelectDropdown from '@/components/Form/SelectDropdown'
  import LabelStatus from '@/components/StatusLabel'
  import ListItem from '@/components/ListDemographic'
  import Modal from '@/components/Modal'
  import LoadingPrimary from '@/components/Loading/Primary'

  import api from '@/api'
  import lib from '@/lib/util'
  import {apiV2} from '@/api/urls'
  import {mapGetters} from 'vuex';

  export default {
  name: 'adx-dashboard-campaign-detail',
  components: {
    'adx-empty': Empty,
    'adx-loading': Loading,
    'adx-selectdropdown': SelectDropdown,
    'adx-labelstatus': LabelStatus,
    'adx-list-item': ListItem,
    'adx-modal': Modal,
    'adx-loading-primary': LoadingPrimary,
  },
  props: {

  },
  data() {
    return {
      isLoading: true,
      loadingOverview: false,
      loadingPlacement: false,
      loadingIssue: false,
      startDate:null,
      endDate: null,
      result: [],
      id: null,
      staticCampaignId: null,
      statusCampaign: null,
      placementPage : 1,
      imagesPage : 1,
      issuesPage : 1,
      latestUpdated: null,
      normal: 0,
      warning: 0,
      out_of_service: 0,
      all_normal: 0,
      all_warning: 0,
      all_out_of_service: 0,
      campaign_title: null,
      isImagePreview : false,
      content: {
        imageId : null,
        imageTitle: null,
        imageUrl: null,
        imageOrientation: null,
        imageType: null,
        thumbnail : null
      },
      locations: [],
      selectedLocation: null,
      options: [],
      selectedOption: null,
      items_issue: [],
      contents:[],
      tmpContents:[],
      placements: [],
      status:[
        {
          data: {
            header: [''],
            body: [{percent : 0}]
          },
          color: 'bar-green'
        },
        {
          data: {
          header: [''],
          body: [{percent : 0}]
          },
          color: 'bar-yellow'
        },
        {
          data: {
          header: [''],
          body: [{percent : 0}]
          },
          color: 'bar-red'
        },
      ],
      optionImages: null,
      optionImagesPage: 1
    }
  },
  computed: {
    ...mapGetters({
        user: 'account',
        token: 'token'
    }),
    // loadingOverview: function (){
    //   return this.placements.length > 0 && this.status > 0 ? true : false
    // },
    slicedPlacement: function () {
      let itemPerPage = 4;
      let start = (this.placementPage*itemPerPage) - itemPerPage;
      let end = (this.placements.length%itemPerPage===0 || this.placementPage===1) && this.placements.length>=itemPerPage ?
              this.placementPage * itemPerPage  :
              (this.placementPage * itemPerPage - 3) + (this.placements.length % itemPerPage);
      return this.placements.slice(start, end)
    },
    slicedImagesList: function () {
      let itemPerPage = 10;
      let start = (this.imagesPage*itemPerPage) - itemPerPage;
      let end = (this.contents.length%itemPerPage===0 || this.imagesPage===1) && this.contents.length>=itemPerPage ?
              this.imagesPage * itemPerPage :
              (this.imagesPage * itemPerPage - 9) + (this.contents.length % itemPerPage);
        return this.contents.slice(start, end)
    },
    slicedIssueList: function () {
      let itemPerPage = 10;
      let start = (this.issuesPage*itemPerPage) - itemPerPage;
      let end = (this.items_issue.length%itemPerPage===0 || this.issuesPage===1) && this.items_issue.length>=itemPerPage ?
              this.issuesPage * itemPerPage :
              (this.issuesPage * itemPerPage - 9) + (this.items_issue.length % itemPerPage);
        return this.items_issue.slice(start, end)
    },
    placementMaxPage(){
      return Math.ceil(this.placements.length / 4);
    },
    imagesMaxPage(){
      return Math.ceil(this.contents.length / 10);
    },
    issueMaxPage(){
      return Math.ceil(this.items_issue.length / 10);
    },
    getFilterParams: function () {
      return {
        listing__location_name : this.selectedLocation !== 'All' ? this.selectedLocation : undefined,
        listing__placement : this.selectedOption !== 'All' ? this.selectedOption : undefined,
        page: this.optionImagesPage ? this.optionImagesPage : undefined
      }
    }
  },
  watch: {
    optionImagesPage: function () {
      this.getImage()
    }
  },
  beforeCreate() {

  },
  created() {

  },
  async beforeMount() {
    this.id = this.$route.params.id;
    await this.getDetail();
    // this.getDataFilter();
    // this.$nextTick(function () {
      // this.getImage();
      // this.getIssueList();
    // })
  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    displayPeriod(startDate, endDate) {
      return `${lib.formatShortDate(startDate)} - ${lib.formatShortDate(endDate)}`
    },
    displayStatus(status) {
      return lib.displayLabelStatus(status)
    },
    previousPlacement(){
      if(this.placementPage > 1)
        this.placementPage--;
    },
    nextPlacement(){
      if(this.placementPage < this.placementMaxPage){
        this.placementPage++;
      }
    },
    previousImages(){
      if(this.optionImagesPage > 1)
          this.optionImagesPage--;
    },
    nextImages(){
      if(this.optionImagesPage < this.optionImages.max_page){
          this.optionImagesPage++;
      }
    },
    previousIssues(){
      if(this.issuesPage > 1)
          this.issuesPage--;
    },
    nextIssues(){
      if(this.issuesPage < this.issueMaxPage){
          this.issuesPage++;
      }
    },
    closeModalPreview(){
      this.isImagePreview = false
    },
    imagePreview(item){
      window.open(item.image, '_blank');
    },
    async getDetail(){
      this.isLoading = true;
      const response = await api.get(apiV2.dashboardParentCampaign(this.id), {needToken:true});
      if (response.status == 200) { 
        let data = response.data
        this.campaign_title = data.title;
        this.startDate = data.start
        this.endDate = data.end
        this.statusCampaign = data.status
        this.staticCampaignId = await data.static_campaign
        this.getOverview()
        this.getIssueList()
        this.getDataFilter()
        this.isLoading = false
      }
    },
    async getOverview(){
      this.loadingOverview = true
      const response = await api.get(apiV2.monitoringCampaignDashboardDetail(this.staticCampaignId), {needToken:true});
      if (response.status == 200) { 
        let data = response.data
       
        //mapping detail campaign
        this.latestUpdated = data.latest_report_date;
        let issue_count = data.issue_count;
        let all_issue_count = data.all_issue_count;
        let placement_status = data.listing_set;

        this.normal = issue_count.normal;
        this.warning = issue_count.warning;
        this.out_of_service = issue_count.out_of_service;

        //mapping all status
        this.status[0].data.body[0].percent = all_issue_count.normal;
        this.status[1].data.body[0].percent = all_issue_count.warning;
        this.status[2].data.body[0].percent = all_issue_count.out_of_service;


        // mapping placement status
        let result = [];
        await data.listing_set.map( res => {
          let status = {
            label: res.status_display.toUpperCase(),
            value: res.status_display.toLowerCase()
          };

          result.push({
            placement: res.location_name + '-' + res.placement,
            status: status
          })
        });
        this.placements = result;
        this.loadingOverview = false
      }
    },
    async getImage(){
      this.loadingPlacement = true;
      let params = {
        ...this.getFilterParams
      };
      const { data } = await api.get(apiV2.monitoringIssueImage(this.staticCampaignId), {needToken:true, params});
      let images = [];
      let body = [];

      const { results, ...rest } = data

      await results.map( res => {
        let status = {
          label: res.status_display.toUpperCase(),
          value: res.status_display.toLowerCase().replace(/\s/g, '')
        };
        res.images.map( image => {
          images.push({
            image: image.image,
            filename: image.filename,
            imageId: image.id,
            thumbnail: image.thumbnail,
          })
        });
        body.push({
          location: res.listing_location,
          placement: res.listing_placement,
          status: status,
          date: res.date,
          images: images,
          title: res.listing_location,
        })
        images = [];
      });
      this.optionImages = rest

      this.tmpContents = body;
      this.contents = body;
      this.loadingPlacement = false;
    },
    async getIssueList(){
      this.loadingIssue = true;
      const { data } = await api.get(apiV2.monitoringIssueList(this.staticCampaignId), {needToken:true});
      this.items_issue = data;
      this.loadingIssue = false;
    },
    async getDataFilter(){
      this.isLoading = true;
      const { data } = await api.get(apiV2.monitoringPopulateImageFilter(this.staticCampaignId), {needToken:true});
      this.populateLocationFilter(data.locations)
      this.populatePlacementFilter(data.placements)
      this.getImage()
      this.isLoading = false;
    },
    async populateLocationFilter(locations){
      let tmpLocations = [];
      await locations.map( res => { 
        tmpLocations.push({
          label: res.value,
          value: res.value,
        });
      });
      
      this.locations = tmpLocations;
      this.selectedLocation = tmpLocations[0].value
    },
    async populatePlacementFilter(placements){
      let tmpPlacements = [];
      await placements.map( res => {
        tmpPlacements.push({
          label: res.value,
          value: res.value,
        });
      });

      this.options = tmpPlacements;
      this.selectedOption = tmpPlacements[0].value  
    },
    onLocationSelected(item){
      this.selectedLocation = item.item.value;
      this.getImage()
    },
    onPlacementSelected(item){
      this.selectedOption = item.item.value;
      this.getImage()
    },
    formatDate(date) {
      if (date) {
        const dateFormat = moment(date, 'DD/MM/YYYY');
        return dateFormat.format('ddd, DD MMMM YYYY')
      }
      return '-'
    },
    formatShortDate(date){
      const issue_date = moment(date, 'DD/MM/YYYY');
      return issue_date.format('DD MMMM YYYY')
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>

<style lang='scss'>
@import '~@/styles/variables';
@import '~@/styles/mixins';

.exBranding-monitoring{
  .listDemographic table thead tr > th{
    display: none;
  }

  .listDemographic table td .wrap .caption{
    font-size: 12px;
  }
}

</style>
